import React from "react";

const StyledLabel = ({ htmlFor, children, style, ...props }: any) => {
  const baseStyle = {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    fontWeight: 600,
    color: "#333",
    letterSpacing: "0.4px",
  };

  const combinedStyle = { ...baseStyle, ...style };

  return (
    <label htmlFor={htmlFor} style={combinedStyle} {...props}>
      {children}
    </label>
  );
};

export default StyledLabel;
